/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { api, asJson } from '../lib/api.js';
import { PB_URL } from '../lib/config.js';
import * as store from '../lib/store.js';

export default {
  openTheme() { return this.setState({ themePopup: true }); },

  openThemeList() { return this.setState({ dialog: 'themeList', themeError: '' }, this.fetchThemes); },

  // De thema's staan op de server, zodat iedereen dezelfde lijst ziet.
  // Staat er niets, dan gelden de ingebouwde 31.
  async fetchThemes() {
      if (!PB_URL) return;
      try {
        const res = await api(`${PB_URL}/api/collections/paal_themes/records?perPage=50`);
        if (res.status === 404) { this.setState({ themeError: 'Maak op de server een collectie “paal_themes” met een getalveld day en een tekstveld word.' }); return; }
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        const words = {};
        const stamps = {};
        this.themeRecs = {};
        (data.items || []).forEach((r) => {
          const d = Number(r.day);
          if (!d || d < 1 || d > 31) return;
          // Staan er meer records voor dezelfde dag, dan wint de nieuwste.
          const t = Date.parse(r.updated || r.created || '') || 0;
          if (stamps[d] != null && t < stamps[d]) return;
          stamps[d] = t;
          this.themeRecs[d] = r.id;
          if (r.word) words[d] = r.word; else delete words[d];
        });
        // Een net opgeslagen woord mag niet worden overschreven door een
        // antwoord dat nog van vóór die opslag komt.
        const pending = this.themePending || {};
        Object.keys(pending).forEach((d) => { words[d] = pending[d]; });
        this.setState({ themeWords: words });
      } catch (e) {}
    },

  async saveTheme(day, word) {
      const clean = (word || '').trim().slice(0, 40);
      const words = { ...this.state.themeWords };
      if (clean) words[day] = clean; else delete words[day];
      this.setState({ themeWords: words });
      if (!PB_URL) return;
      if (!this.themePending) this.themePending = {};
      this.themePending[day] = clean;
      const id = this.themeRecs ? this.themeRecs[day] : null;
      const data = { day, word: clean };
      try {
        const res = id
          ? await api(`${PB_URL}/api/collections/paal_themes/records/${id}`, asJson('PATCH', data))
          : await api(`${PB_URL}/api/collections/paal_themes/records`, asJson('POST', data));
        if (!res.ok) throw new Error(res.status);
        const rec = await res.json();
        if (!this.themeRecs) this.themeRecs = {};
        if (rec && rec.id) this.themeRecs[day] = rec.id;
        this.setState({ themeError: '' });
        // Even vasthouden tot de server het echt teruggeeft.
        setTimeout(() => { if (this.themePending) delete this.themePending[day]; }, 6000);
      } catch (e) {
        if (this.themePending) delete this.themePending[day];
        this.setState({ themeError: 'Opslaan mislukt. Bestaat de collectie “paal_themes” met velden day (getal) en word (tekst)?' });
      }
    },

  closeThemeList() { return this.setState({ dialog: 'mod' }); },

  hideTheme() {
      // Wie het balkje wegklikt, ziet het vandaag niet meer terug.
      store.set('gp_theme_hide_' + this.themeDayKey(), '1');
      this.setState({ themeHidden: true });
    },

  closeTheme() { return this.setState({ themePopup: false }); }
};
